<!-- Cookie consent: Show if NOT accepted -->
 @if (showConsent && !approved) {
    <div class="sx-cookie-consent">
        <div class="cookie-info not-approved">
            <div class="container">
                <div class="row">
                    <div class="col-xlg-8 col-md-7 col-sm-8 col-xs-12 cookie-info__text">
                        {{'cookie_consent.info' | translate}}​   	
                    </div>		
                    <div class="col-xlg-2 col-md-3 col-sm-4 col-xs-12">
                        <button type="button" class="btn cookie-info__approve-btn sx-button" (click)="onApprove()">{{'cookie_consent.approve' | translate}}​</button>
                    </div>
                    <div class="col-xlg-2 col-md-2 col-sm-4 col-xs-12">
                        <a href="https://www.stockholmexergi.se/cookies/" class="btn cookie-info__readmore-btn sx-button">{{'cookie_consent.read_more' | translate}}</a>
                    </div>	
                </div>
            </div>
        </div>
    </div>
}
